import React, { FC, useMemo } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { CloseOutlined } from '@material-ui/icons';

import { getStatusLabel, statusesDashboard } from 'interfaces/dashboard';
import StatusByDayTable from '../Tables/StatusByDay';
import { useSnapshots } from '../context/SnapshotsContext';

type Props = {
  open: boolean;
  date?: Date;
  ventureId: number;
  categoryId?: number;
  entityId?: number;
  status?: statusesDashboard;
  onClose: () => void;
};

const DialogStatusByDay: FC<Props> = (props) => {
  const {
    onClose: handleClose,
    open,
    status,
    date,
    ventureId,
    categoryId,
    entityId,
  } = props;
  const dateString = useMemo(
    () => (date ? `- ${date.toLocaleDateString('pt-BR')}` : null),
    [date]
  );
  const { selectedSnapId } = useSnapshots();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="simple-Dialog-title"
      aria-describedby="simple-Dialog-description"
      fullWidth
      maxWidth="md"
    >
      <DialogActions
        style={{ alignItems: 'flex-start', justifyContent: 'space-between' }}
      >
        <DialogTitle>
          {status ? getStatusLabel(status) : ''} {dateString}
        </DialogTitle>
        <IconButton onClick={handleClose}>
          <CloseOutlined />
        </IconButton>
      </DialogActions>
      <DialogContent>
        <StatusByDayTable
          ventureId={ventureId}
          status={status}
          snapshotId={selectedSnapId ? String(selectedSnapId) : undefined}
          categoryId={categoryId}
          entityId={entityId}
        />
      </DialogContent>
    </Dialog>
  );
};

export default DialogStatusByDay;
